import React from 'react';

import { AddIconButton } from 'packages/common-frontend/components/IconButton';

export const AddButton: React.FC<{
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ setIsOpen }) => {
  return (
    <AddIconButton
      ariaLabel="add"
      label="Add"
      onClick={() => setIsOpen(true)}
    />
  );
};
